class HeaderElement extends HTMLElement {
  connectedCallback () {
    this.setupDesktopMenu()
    this.setupMobileMenu()
    this.setupSearchModal()
  }

  setupDesktopMenu () {
    this.menuDesktopParents.forEach(menuDesktopParent => {
      const menuDrawer = menuDesktopParent.querySelector('[menu-drawer]')
      if (!menuDrawer) return
      menuDesktopParent.addEventListener('mouseover', () => {
        menuDrawer.classList.remove('invisible', 'opacity-0')
        this.toggleSearchModal(false)
        window.dispatchEvent(new CustomEvent('show:body-obscure'))
      })

      menuDesktopParent.addEventListener('mouseout', () => {
        menuDrawer.classList.add('invisible', 'opacity-0')
        window.dispatchEvent(new CustomEvent('hide:body-obscure'))
      })
    })
  }

  setupMobileMenu () {
    this.openMobileMenuTrigger.addEventListener('click', () => {
      this.toggleMobileMenu(true)
    })

    this.closeMobileMenuTrigger.addEventListener('click', () => {
      this.toggleMobileMenu(false)
    })

    window.addEventListener('show:mobile-menu', () => {
      this.toggleMobileMenu(true)
    })

    window.addEventListener('hide:mobile-menu', () => {
      this.toggleMobileMenu(false)
    })
  }

  setupSearchModal () {
    this.openSearchModal.addEventListener('click', () => {
      this.toggleSearchModal(true)
    })

    this.closeSearchModal.addEventListener('click', () => {
      this.toggleSearchModal(false)
    })

    this.cancelSearchModal.addEventListener('click', () => {
      this.toggleSearchModal(false)
    })

    window.addEventListener('show:search-modal', () => {
      this.toggleSearchModal(true)
    })

    window.addEventListener('hide:search-modal', () => {
      this.toggleSearchModal(false)
    })
  }

  toggleMobileMenu (val) {
    const chatBundle = document.querySelector('.chat-bundle')

    if (val) {
      this.mobileMenu.classList.remove('-translate-x-[102%]')
      this.openMobileMenuTrigger.classList.add('tb-hidden')
      this.closeMobileMenuTrigger.classList.remove('tb-hidden')
      this.toggleSearchModal(false)
      window.dispatchEvent(new CustomEvent('prevent:page-scroll'))
      window.dispatchEvent(new CustomEvent('show:body-obscure'))
      if (chatBundle) chatBundle.style.zIndex = '10'
      return
    }

    this.mobileMenu.classList.add('-translate-x-[102%]')
    this.openMobileMenuTrigger.classList.remove('tb-hidden')
    this.closeMobileMenuTrigger.classList.add('tb-hidden')
    window.dispatchEvent(new CustomEvent('allow:page-scroll'))
    window.dispatchEvent(new CustomEvent('hide:body-obscure'))
    if (chatBundle) chatBundle.style.zIndex = '70'
  }

  toggleSearchModal (val) {
    if (val) {
      this.searchModal.classList.remove('tb-hidden')
      this.openSearchModal.classList.add('tb-hidden')
      this.closeSearchModal.classList.remove('tb-hidden')
      this.toggleMobileMenu(false)
      window.dispatchEvent(new CustomEvent('show:body-obscure'))
      this.searchInput.focus()
      return
    }

    this.searchModal.classList.add('tb-hidden')
    this.openSearchModal.classList.remove('tb-hidden')
    this.closeSearchModal.classList.add('tb-hidden')
    window.dispatchEvent(new CustomEvent('hide:body-obscure'))
  }

  get menuDesktopParents () {
    return this.querySelectorAll('[menu-parent]')
  }

  get mobileMenu () {
    return this.querySelector('[mobile-menu]')
  }

  get openMobileMenuTrigger () {
    return this.querySelector('[open-menu-mobile]')
  }

  get closeMobileMenuTrigger () {
    return this.querySelector('[close-menu-mobile]')
  }

  get searchModal () {
    return this.querySelector('[search-modal]')
  }

  get openSearchModal () {
    return this.querySelector('[open-search-modal]')
  }

  get closeSearchModal () {
    return this.querySelector('[close-search-modal]')
  }

  get cancelSearchModal () {
    return this.querySelector('[cancel-search-modal]')
  }

  get searchInput () {
    return this.querySelector('[search-input]')
  }
}

if (!customElements.get('header-element')) {
  customElements.define('header-element', HeaderElement)
}
